.jb-input-web-component{
    --jb-input-input-direction: var(--jb-mobile-input-input-direction, ltr);
}